import React from 'react'
import { Box, Button, Grid, Typography} from '@mui/material'
import buttonStyle from '../../../styles/buttonStyle'
import AddIcon from '@mui/icons-material/Add';
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import dataGridStyle from '../../../styles/dataGridStyle';
import ActionButtons from '../../../components/ActionButtons';
import { useNavigate } from 'react-router-dom';

function CustomColumnMenu(props) {
  return (
    
    <GridColumnMenu
      {...props}
      slots={{
     // Hide `columnMenuColumnsItem`
      columnMenuColumnsItem: null,
      columnMenuSortItem: null,
      }}
    />
    
);
}
const columns = [
{ field: 'SNNo', headerName: 'SNNo', editable: false, sortable: false,minWidth: 100 },
{ field: 'OpenDate', headerName: 'Open Date', editable: false, sortable: false, minWidth: 100},
{ field: 'Vehicle', headerName: 'VRM', editable: false, sortable: false, minWidth: 100 },
{ field: 'Owner', headerName: 'Owner', editable: false, sortable: false,flex: 1,  minWidth: 100 },
{ field: 'TotalAmount', headerName: 'Total Amount', editable: false, sortable: false, minWidth: 100},
{ field: 'CloseDate', headerName: 'Close Date', sortable: false, minWidth: 110},
{ field: 'Supervisor', headerName: 'Supervisor', sortable: false, flex: 1, minWidth: 110},
{ field: 'status', headerName: 'Status', editable: false, sortable: false, flex: 1, minWidth: 100},
{ field: 'action', headerName: 'Actions', sortable: false, flex: 1, minWidth: 180, renderCell: (params) => {
  return (
  <ActionButtons title='Convert To Service Order' status={params.row.status!=="Invoice"?true:false} page='Invoice_Genaration'/>
  );
  }}
];

const rows = [
{ SNNo: 2351, OpenDate: '10-05-2023', Vehicle: 'KZ66 ZYT', Owner: 'Oliver Jake Jack Connor',status:'Allocated', TotalAmount: '20', CloseDate:'10-05-2023', Supervisor:'William' },
{ SNNo: 2352, OpenDate: '10-05-2023', Vehicle: 'OZ70 ZEV', Owner: 'John Fitzgerald Kennedy' ,status:'Work In Progress', TotalAmount: '20', CloseDate:'10-05-2023', Supervisor:'Jackson' },
{ SNNo: 2353, OpenDate: '10-05-2023', Vehicle: 'PZ65 PWO', Owner: 'Alexander Anthony Benjamin' ,status:'Invoice', TotalAmount: '20', CloseDate:'10-05-2023', Supervisor:'Sebastian' },
{ SNNo: 2354, OpenDate: '10-05-2023', Vehicle: 'HZ13 WDD', Owner: 'Liam John Mason Robert' ,status:'Allocated', TotalAmount: '20', CloseDate:'10-05-2023', Supervisor:'Michael' },
{ SNNo: 2355, OpenDate: '10-05-2023', Vehicle: 'PZ65 BYV', Owner: 'Christopher Dominic Gabriel' ,status:'Invoice', TotalAmount: '20', CloseDate:'10-05-2023', Supervisor:'Alexander' },
];
function Allservice() {
    const navigate = useNavigate()
    return (
        <Grid container spacing={1}>
          <Grid item xs={12} mt={1}>
            <Box sx={dataGridStyle.root}>
              <DataGrid
                columnHeaderHeight={42}
                rowHeight={40}
                rows={rows}
                columns={columns}
                getRowId={(row) => row.SNNo}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                pageSizeOptions={[10]}
                slots={{ columnMenu: CustomColumnMenu }}
                disableRowSelectionOnClick
              />
            </Box>
          </Grid>
        </Grid>
    )
    }
export default Allservice